<template>
  <div class="block-container" v-if="!loading">
    <div class="block-title">
      <div>精选专题</div>
      <div class="all-topics">
        <div
          @click="topicsAll"
          style="margin-right:5px;"
        >全部专题</div>
        <van-icon name="arrow" />
      </div>
    </div>
    <div
      v-if="config.direction == 'vertical'"
      class="outer-container"
    >
      <!-- 纵向滚动 -->
      <van-swipe
        v-if="swipeShow"
        ref="swipe"
        :autoplay="config.duration>0 ? config.duration : 3000"
        vertical
        :show-indicators="false"
        indicator-color="white"
        :style="swipeStyle"
        @change="swipeChange"
      >
        <van-swipe-item
          v-for="topic in topics"
          :key="topic.id"
          @click="clickItem(topic.id)"
        >
          <topics
            :slug="slug"
            :topic-data="topic"
            @imageonload="imageOnLoad"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div
      v-else
      class="outer-container"
    >
      <!-- 横向滚动 -->
      <van-swipe
        v-if="swipeShow"
        ref="swipe"
        :autoplay="config.duration>=0 ? config.duration : 3000"
        :show-indicators="true"
        indicator-color="white"
      >
        <van-swipe-item
          v-for="topic in topics"
          class="horizontal-swipe-item"
          style=""
          :key="topic.id"
          @click="clickItem(topic.id)"
        >
          <topics
            :slug="slug"
            :topic-data="topic"
            @imageonload="imageOnLoad"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
  import Topics from './topics.vue'
  import { Swipe, SwipeItem } from 'vant'
  import Vue from 'vue'
  Vue.use(Swipe, SwipeItem)

  export default {
    name: "BlockTopic",
    components: {
      Topics
    },
    data () {
      return {
        loading: true,
        slug: '', // show 的 slug
        topics: [], // 未隐藏的节目公告
        config: {}, // 设置
        swipeShow: true,
        swipeStyle: {
          height: '157px',
          borderRadius: '4px'
        }
      }
    },
    methods: {
      getTopicConfig: function () {
        let that = this
        let params = {
          show__slug: that.slug
        }
        that.$api.topicConfig.list(params).then(res => {
          window.console.log("获取到 topic config")
          window.console.log(res)
          if (res.data.count > 0) {
            if (res.data.results[0].enable) {
              window.console.log("Topic区块已启用")
              that.getTopics()
              that.config = res.data.results[0]
            } else {
              window.console.log("Topic区块已禁用")
            }
          } else {
            window.console.log("未找到相关配置")
          }
        })
      },
      getTopics: function () {
        let that = this
        let params = {
          slug: that.slug,
          hidden: false,
          limit: 5
        }
        that.$api.topic.list(params).then(res => {
          window.console.log("获取到未隐藏的 Topic 列表")
          window.console.log(res)
          that.topics = res.data.results
        })
      },
      imageOnLoad: function (e) {
        // window.console.log("imageOnLoad:", e)
        let swipeStyle = this.swipeStyle
        swipeStyle.height = e.imageHeight
        this.swipeStyle = swipeStyle
      },
      swipeChange: function (e) {
        if (e == 0) {
          this.$refs.swipe.resize()
        }
      },
      clickItem: function (topicId) {
        window.console.log("clickItem:", topicId)
        this.$router.replace({
          name: 'TopicDetail',
          params: {
            topicId: topicId
          }
        })
      },
      topicsAll: function () {
        this.$router.replace({
          name: 'TopicsAll',
          params: {}
        })
      }
    },
    watch: {
      // 横向跑马灯 topic 有一个 bug
      // 切到别的页面再切回来就会不显示
      // 这里监听切换状态，再重新显示此区块可规避此 bug
      $route(to, from){
        if (from != to && from.name == 'Discovery') {
          this.swipeShow = false
        }
        if (to != from && to.name == 'Discovery') {
          this.swipeShow = true
        }
      },
      'topics': function (topics) {
        if (topics.length > 0) {
          this.loading = false
        }
      },
    },
    mounted () {
      this.slug = this.$route.params.slug
      this.getTopicConfig()
      // window.console.log("组件被加载")
    },
    destroyed () {
      // window.console.log("组件被销毁")
    }
  }
</script>

<style lang="css" scoped>
.block-container {
  border-top: 1px solid #ebedf0;
  border-bottom: 1px solid #ebedf0;
}
.block-title {
  background: #fff;
  padding: 10px 16px 0px 16px;
  color: #228df6;
  font-weight: bold;
  /* margin-bottom: 5px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.outer-container {
  /* width: 100%; */
  /* overflow: scroll; */
  background: #fff;
  padding: 10px 16px 16px 16px;
}
.all-topics {
  display: flex;
  align-items: center;
  color: #bcbdc0;
  font-size: 0.75em;
}
</style>
